import { useEffect } from 'react';
import { SNAPCHAT_READY_EVENT } from '@/lib/analytics/snapchat/constants';
import { isSnapchatEnabled } from '@/lib/analytics/snapchat/client';
import { useSnapchatEnabled } from '@/lib/analytics/snapchat/useSnapchatEnabled';
import { useAuthState } from '../context/AuthContext';

const SnapchatPixelUpdater = () => {
  const { user, isLoggedIn } = useAuthState();
  const snapchatEnabled = useSnapchatEnabled();

  useEffect(() => {
    if (!snapchatEnabled || typeof window === 'undefined' || !isLoggedIn || !user?.email) {
      return;
    }

    const updateSnapchatUser = () => {
      if (!isSnapchatEnabled() || !window.snaptr) {
        return;
      }

      window.snaptr('user', {
        user_email: user.email,
      });
    };

    updateSnapchatUser();
    if (window.snaptr) {
      return;
    }

    window.addEventListener(SNAPCHAT_READY_EVENT, updateSnapchatUser);
    return () => window.removeEventListener(SNAPCHAT_READY_EVENT, updateSnapchatUser);
  }, [snapchatEnabled, isLoggedIn, user?.email]);

  return null;
};

export default SnapchatPixelUpdater;
